<template>
<div>
  <div class="join-modal-mask" v-if="visible">
    <div class="join-modal">
      <img class="modal-top-bg" src="https://image.xiaomaiketang.com/xm/Aem7CJppKf.png" />
      <div class="modal-content">
        <div class="modal-title">加入学习</div>
        <wheat-input
          placeholder="学员姓名"
          :value="studentName"
          @change="handleChangeName"
          class="student-input"
          :blur='blurInput()'
          :class="inputTips === '请输入学员姓名' ? 'input-error' : ''"
          :maxLength="15"
        ></wheat-input>
        <wheat-input
          type="tel"
          placeholder="手机号"
          :value="phone"
          :blur='blurInput()'
          @change="handleChangePhone"
          class="student-input"
          :maxLength="11"
          :class="(inputTips === '请输入手机号' || inputTips === '手机号格式错误') ? 'input-error' : ''"
        ></wheat-input>
        <div 
          class="code" 
          :class="(inputTips === '验证码格式错误') ? 'code-border' : ''" 
          v-if="smsCheck"    
        >
          <wheat-input
            placeholder="验证码"
            class="code-input"
            :value="code"
            :maxLength="4"
            :blur='blurInput()'
            @change="handleChangeCode"
          ></wheat-input>
          <span 
            class='code-tip' 
            :class="!showButton ? '' : 'code-tip-2'"
            @click="showGetCodeError"
          >
            收不到？
          </span>
          <span class='get-code-line'></span>
          <div class='get-code'>
            <span v-if="showButton" @click="handleSlide">获取验证码</span>
            <span v-if="!showButton">{{Num}}s</span>
          </div>
        </div>
        <div :class="smsCheck ? 'input-tips-1' : 'input-tips-2'">{{inputTips}}</div>
        <div class="cancle-btn" @click="handleCancel" v-if="smsCheck">取消</div>
        <div 
          :class="smsCheck ? 'ok-btn' : 'no-sms-ok'"
          @click="handleOk"
        >
          确定
        </div>
        <img 
          class='iconfont-error'
          @click="handleCancel" 
          src="https://image.xiaomaiketang.com/xm/Sj4YRTrrjQ.png" 
          alt=""
        >
      </div>
    </div>
  </div>
  <!-- 语音验证 -->
  <div class='code-error' v-if="getCodeError && smsCheck">
    <div class="get-code-error">
      <div class="get-code-error-tip">
        是否已电话的方式，获取语音验证码？
      </div>
      <div class="get-code-error-button">
        <div class="left" @click="closeCodeError">取消</div>
        <div class='right' @click="handleSlide">接听</div>
      </div>
    </div>
  </div>
  <!-- 短信余额不足  -->
  <div class='sms-not-enough' v-if="!hasSms && smsCheck">
    <div class='code-not-enough'>
      <div class='sms-body'>
        <div class='sms-container'>
          <span>{{ errorInfo }}</span>
        </div>
      </div>
      <div class="sms-button" @click="closeSmsTip"> 
        我知道了
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'join-modal',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    smsCheck: {
      type: Boolean,
      required: true,
      default: false,
    },
    instId: {
      type: String,
      required: true,
    },
    serverType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      studentName: "",
      phone: "",
      inputTips: "",
      showButton: true,
      timer: null,
      Num: 60,                       
      code: "",                      
      getCodeError: false,          
      hasSms: true,                 
      errorInfo: '',                 
      certificate: '',
      voiceQuery: {
        csessionid: '',
        sig: '',
        token: '',
      },
    };
  },
  methods: {
    handleChangeName(value) {
      this.inputTips = "";
      this.studentName = value;
    },

    handleChangePhone(value) {
      this.inputTips = "";
      this.phone = value;
    },

    handleChangeCode(value) {
      this.inputTips = "";
      this.code = value;
    },
    closeSmsTip() {
      this.hasSms = !this.hasSms;
    },
    // 打开滑块验证
    handleSlide() {
      if (this.phone.length === 11) {
        window._xm_slide.open();
      } else {
        this.inputTips = "请输入11位手机号码";
      }
    },
    showGetCodeError() {
      if (!this.showButton) {
        this.getCodeError = true;
      }
    },
    // 获取验证码
    getCode(query) {
      clearInterval(this.timer);
      if (this.phone.length === 11 && this.studentName !== '') {
        const params = {
          sig: query.sig,
          sessionId: query.csessionid,
          token: query.token,
          phone: this.phone,
          instId: this.instId,
          serverType: this.serverType,
          scene: "nc_login_h5",
          sideType: 0,
        };
        axios.post('apollo/anon/apollo/sendMachineCheckJoinAuthCode', params).then((res) => {
          if (res.success === true) {
            if (res.result) {
              this.certificate = res.result;
            }
            this.showButton = false;
            this.timer = setInterval(() => {
              this.Num -= 1;
              if (this.Num < 1) {
                this.showButton = true;
                clearInterval(this.timer);
                this.Num = 60;
              }
            }, 1000);
          } else {
            this.errorInfo = res.message;
          }
        }).catch((res) => {
          console.log('res', res);
          this.errorInfo = res.data.message;
          this.hasSms = false;
          if (res.code === 'VERIFY_CODE_ERROR') {
            this.$wheatModal.confirm({
              title: "",
              content: "当前无法发送短信验证码，请联系机构处理。联系电话：19850011212",
              okText: "我知道了",
              oneBtn: true,
            });
          }
        });
      } else if (this.studentName === '') {
        this.inputTips = '请输入学员姓名';
      } else {
        this.inputTips = '请输入11位手机号码';
      }
    },

    // 语音验证
    verificationByPhone() {
      const { sig, csessionid, token } = this.voiceQuery;
      const params = {
        certificate: this.certificate,
      };
      axios.post('apollo/anon/apollo/voiceCode', params).then((res) => {
        if (res.success) {
          this.getCodeError = false;
          // this.handleCancel();
        }
      });
    },

    closeCodeError() {
      this.getCodeError = false;
    },

    handleOk() {
      if (!this.studentName || new RegExp("^[ ]+$").test(this.studentName)) {
        this.inputTips = "请输入学员姓名";
        return;
      }
      if (!this.phone || new RegExp("^[ ]+$").test(this.phone)) {
        this.inputTips = "请输入手机号";
        return;
      }
      if (this.phone.length !== 11) {
        this.inputTips = '手机号格式错误';
        return;
      }
      if (this.smsCheck && this.code.length !== 4) {
        this.inputTips = '验证码格式错误';
        return;
      }
      const params = {
        stuName: this.studentName,
        stuPhone: this.phone,
        code: null,
      };
      this.smsCheck && (params.code = this.code);
      this.timer = null;
      this.$emit("ok", params);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },

    handleCancel() {
      this.showButton = true;
      this.Num = 60;
      this.inputTips = '';
      this.$emit("cancel");
      clearInterval(this.timer);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // ios12 软键盘弹起使页面按钮响应区域改变解决方案
    blurInput() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      const dom = document.querySelector('.xm-page');
      dom && dom.scrollTo(0, 0);
    },

    clearInfo() {
      this.studentName = '';
      this.phone = '';
      this.code = '';
    },
  },
  mounted() {
    window._xm_slide.init();
    window.addEventListener("message", (e) => {
      window._xm_slide.remove();
      if (e.data.token) {
        this.voiceQuery = e.data;
        if (this.getCodeError) {
          this.verificationByPhone();
        } else {
          this.getCode(e.data);
        }
      }
    });
  }
}
</script>

<style lang="less">
.join-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 199;
  .join-modal {
    width: 6.3rem;
    height: 8rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.24rem;
    .modal-top-bg {
      width: 100%;
    }
    .modal-content {
      padding: 0 0.48rem;
      .modal-title {
        margin: 0.48rem 0;
        font-size: 0.42rem;
        color: #333;
        text-align: center;
        font-weight: 500;
      }
      .input-error {
        > input {
          border: 0.02rem solid #EC4B35;
        }
      }
      .student-input {
        margin-bottom: 0.16rem;
      }
      .code {
        height: 0.8rem;
        border: 0.02rem solid #e8e8e8;
        border-radius: 0.08rem;
        position: relative;
        text-align: left;
        .code-input{
          width: 3.5rem;
        }
        .wheat-input{
          border: none !important;
          outline: medium !important;
        }
        .get-code-line{
          position: absolute;
          margin-right:8px;
          width: 10px;
          height: 0.5rem;
          font-size: 0.5rem;
          top: 0.15rem;
          right: 1.5rem;
          border-left: 1px solid #e8e8e8;
        }
        .get-code{
          position: absolute;
          margin-bottom: 0.16rem;
          top: 0.045rem;
          height: 0.76rem;
          left: 3.5rem;
          width: 1.75rem;
          border-left: none;
          text-align: center;
          line-height: 0.75rem;
          font-size: 0.3rem;
          color:  #3296fa;
        }
        .code-tip{
          position: absolute;
          background-color:#ECF5FD;
          color:  #3296fa;
          top: 0.2rem;
          right: 2rem;
          border-radius: 4px;
          z-index: 200;
        }
        .code-tip-2{
          opacity: 0;
        }
      }
      .code-border{
        border: 1px red solid;
        border-radius: 4px;
      }
      
      .input-tips-1 {
        position: absolute;
        height: 0.42rem;
        line-height: 0.42rem;
        color: #ec4b35;
        font-size: 0.3rem;
        bottom: 1.55rem;
      }
      
      .input-tips-2{
        position: absolute;
        height: 0.42rem;
        line-height: 0.42rem;
        color: #ec4b35;
        font-size: 0.3rem;
        bottom: 2.65rem;
      }

      .ok-btn {
        width: 2.5rem;
        height: 0.88rem;
        line-height: 0.88rem;
        text-align: center;
        background: #3296fa;
        border-radius: 0.1rem;
        margin-left: 0.24rem;
        margin-top: 0.7rem;
        color: #fff;
        font-size: 0.3rem;
        float: left;
      }
      .no-sms-ok{
        position: absolute;
        bottom: 1.5rem;
        width:5.3rem;
        margin: 0;
        height: 0.88rem;
        line-height: 0.88rem;
        text-align: center;
        background: #3296fa;
        border-radius: 0.1rem;
        color: #fff;
        font-size: 0.3rem;
      }
      .cancle-btn {
        color: #666;
        width: 2.5rem;
        height: 0.86rem;
        border: 1px #e2dfdf solid;
        border-radius: 0.1rem;
        margin-top: 0.7rem;
        font-size: 0.3rem;
        line-height: 0.88rem;
        text-align: center;
        float: left;
      }
      .iconfont-error{
        position: absolute;
        width: 0.5rem;
        height: 0.5rem;
        bottom: -1rem;
        left: 3rem;
      }
    }
  }
}
.code-error{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
  .get-code-error{
    width: 6.2rem;
    height: 3rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.24rem;
    z-index: 200;
    .get-code-error-tip{
      height: 1.6rem;
      width: 5.6rem;
      font-size: 0.4rem;
      line-height: 0.8rem;
      margin: 0.2rem 0.3rem 0.2rem 0.3rem;
    }
    .get-code-error-button{
      font-size: 0.4rem;
      color: #3296fa;
      .left{
        float: left;
        width: 3.05rem;
        height: 1rem;
        line-height: 1rem;
        border-right: 1px solid #E8E8E8;
        border-top: 1px solid #E8E8E8;
        text-align: center;
      }
      .right{
        float: left;
        width: 3.05rem;
        height: 1.2rem;
        line-height: 1rem;
        text-align: center;
        border-top: 1px solid #E8E8E8;
      }
    }
  }
}
.sms-not-enough{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
  .code-not-enough{
    width:6.3rem;
    height: 3rem;
    background-color: #fff;
    position: absolute;
    left: 10%;
    top: 40%;
    border-radius: 0.24rem;
    .sms-body{
      font-size: 0.32rem;
      height: 2rem;
      line-height: 0.5rem;
      top:0.3rem;
      border-bottom: 1px solid #E8E8E8;
      .sms-container{
        padding: 0.5rem 0.3rem 0.5rem 0.3rem;
        .inst-phone{
          color:#ff6700;
        }
      }
    }
    .sms-button{
      font-size: 0.35rem;
      text-align: center;
      padding-top: 0.2rem;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/JoinModal.vue